/// <reference path='../../interfaces/interfaces.d.ts' />

import IToasterService = toaster.IToasterService;
import IFormController = angular.IFormController;
import {IStateService} from 'angular-ui-router';

'use strict';

class EditEventController {
    public static $inject = [
        '$state',
        '$uibModal',
        'User',
        'Calendar',
        'toaster',
        'bsLoadingOverlayService'
    ];

    public datePickerConfig;
    public repeatCases;
    public hasPermission;
    public isRepeated: boolean;
    public eventTypes;
    public eventTypeIcons;

    public event: IEvent = {
        id: undefined,
        title: '',
        allDay: false,
        dayDifference: 0,
        startTime: moment(),
        endTime: moment().add(15, 'minutes'),
        startDate: moment().toDate(),
        endDate: moment().toDate(),
        description: '',
        start: undefined,
        end: undefined,
        rule: undefined,
        calendar_type: undefined,
        end_recurring_period: undefined
    };

    constructor(private $state: IStateService,
                private $uibModal: any,
                private User: IUserService,
                private Calendar: ICalendarService,
                private toaster: IToasterService,
                private bsLoadingOverlayService: IBsLoadingService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.hasPermission = User.hasPermission;
        this.$uibModal = $uibModal;
        if (this.$state.params['calendar_type'] === 'holidays') {
            // holiday events load different fields to normal events therefore are handled differently
            this.Calendar.loadHoliday(this.$state.params['event_id']).then((response: IHolidayResponse) => {
                this.event.id = response.id;
                this.event.startDate = moment(response.start_date).toDate();
                this.event.endDate = moment(response.end_date).toDate();
                this.event.description = response.description;
                this.event.calendar_type = 'holidays';
                this.event.title = response.title;
            }, () => {
                this.$state.go('^');
            });
        } else {
            this.Calendar.loadEvent(this.$state.params['event_id']).then((response: IEventResponse) => {
                this.event.id = response.id;
                this.event.startDate = moment(response.start).toDate();
                this.event.endDate = moment(response.end).toDate();
                this.event.startTime = moment(response.start);
                this.event.endTime = moment(response.end);
                this.event.description = response.description;
                this.event.calendar_type = this.Calendar.parseCalendarType(response.calendar);
                this.event.title = response.title;
                this.event.end_recurring_period = response.end_recurring_period;
                this.event.rule = response.rule;
                this.isRepeated = Boolean(this.event.rule);
                this.Calendar.makeTitle(this.event);
                this.checkAllDayOption();
            }, () => {
                this.$state.go('^');
            });
        }

        this.datePickerConfig = {
            formatDay: 'd',
            formatDayTitle: 'MMM yyyy',
            showWeeks: false
        };

        this.eventTypes = Calendar.getEventTypes();
        this.eventTypeIcons = Calendar.getEventTypeIcons();
        this.repeatCases = Calendar.getRepeatCases();
    }

    public changeAllDay(): void {
        if (this.event.allDay) {
            this.event.startTime.hour(0).minute(0);
            this.event.endDate = this.event.startDate;
            this.event.endTime.hour(23).minute(59);
        } else {
            this.event.startTime.hour(0).minute(0);
            this.event.endTime.hour(23).minute(45);
        }
    }

    public submitForm(form: IFormController): void {
        form.$submitted = true;
        if (form.$valid) {
            this.event.start = moment(this.event.startDate).hour(this.event.startTime.hour()).minute(this.event.startTime.minute());
            this.event.end = moment(this.event.endDate).hour(this.event.endTime.hour()).minute(this.event.endTime.minute());
            if (this.event.start.valueOf() > this.event.end.valueOf()) {
                this.toaster.pop('warning', 'Validation Failed', 'Start date must be earlier than end date!');
            } else {
                let promise: any;
                let removeEventPromise: any;
                // handle holiday events differently to normal events because they take different params
                if (this.event.calendar_type === 'holidays') {
                    if (this.$state.params['calendar_type'] === 'holidays') {
                        // was editing a holiday did not change calendar type to event hence only updated the holiday
                        promise = this.Calendar.updateHoliday(this.event);
                    } else {
                        // was editing a normal event but changed it to holiday hence remove event and create Holiday
                        removeEventPromise = this.Calendar.removeEvent(this.event.id);
                        promise = removeEventPromise.then(() => {
                            return this.Calendar.createHoliday(this.event);
                        }, (response) => {
                            if (response.status === 403) {
                                this.toaster.pop('error', 'Permission Denied', 'You don\'t have permission to delete this event.');
                            } else if (response.status === 400) {
                                this.toaster.pop('warning', 'Validation Failed', response.data);
                            } else {
                                this.toaster.pop('error', 'Server Error', 'There was an error processing your request.');
                            }
                        });
                    }
                } else {
                    if (this.$state.params['calendar_type'] === 'holidays') {
                        if (!this.event.event_type) {
                            this.toaster.pop('error', 'Validation Failed', 'Please select event type');
                            return;
                        }
                        // was editing a holiday but changed it to event hence remove holiday and create event
                        removeEventPromise = this.Calendar.removeHoliday(this.event.id);
                        promise = removeEventPromise.then(() => {
                            return this.Calendar.createEvent(this.event);
                        }, (response) => {
                            if (response.status === 403) {
                                this.toaster.pop('error', 'Permission Denied', 'You don\'t have permission to delete this holiday.');
                            } else if (response.status === 400) {
                                this.toaster.pop('warning', 'Validation Failed', response.data);
                            } else {
                                this.toaster.pop('error', 'Server Error', 'There was an error processing your request.');
                            }
                        });
                    } else {
                        // was editing a normal event did not change calendar type to holiday hence only update event
                        promise = this.Calendar.updateEvent(this.event);
                    }
                }
                promise.then(() => {
                        this.$state.go(this.$state.$current['parent']['navigable']['self']['name']);
                        this.toaster.pop('success', 'Success', 'Event successfully added'); }, 
                    (response: Restangular.IResponse) => {
                        if (response.status === 400) {
                            this.toaster.pop('error', 'Validation Failed', response.data);
                        } else {
                            this.toaster.pop('error', 'Server error', 'Please try again later');
                        }
                });
            }
        } else {
            this.toaster.pop('warning', '', 'Required fields are not filled');
        }
    }

    public discard(): void {
        this.$state.go(this.$state.$current['parent']['navigable']['self']['name']);
    }

    public showRepeatModal(): void {
        if (this.isRepeated) {
            let modalInstance: any = this.$uibModal.open({
                controller: 'RepeatModalController',
                controllerAs: 'modal',
                templateUrl: '/static/templates/modals/repeat_modal.html',
                resolve: {
                    event: (): any => {
                        return this.event;
                    }
                },
            });
            modalInstance.result.then((response: any) => {
                if (response) {
                    this.event.rule = response.rule;
                    this.event.end_recurring_period = response.end_recurring_period;
                }
            }, () => {
                if (!this.event.rule) {
                    this.isRepeated = false;
                    this.repeatedChange();
                }
            });
        }
    }

    public repeatedChange(): void {
        if (!this.isRepeated) {
            this.event.rule = undefined;
            this.event.end_recurring_period = undefined;
        } else {
            this.showRepeatModal();
        }
    }

    public removeEvent = () => {
        let promise: any;
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        if (this.event.calendar_type === 'holidays') {
            promise = this.Calendar.removeHoliday(this.event.id);
        } else {
            let modalInstance: any = this.$uibModal.open({
                controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete event';
                    $scope.modalDetail = 'This event will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete event';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }],
                templateUrl: '/static/templates/modals/confirmation_modal.html'
            });
            // promise = this.Calendar.removeEvent(this.event.id);
            // this.toaster.pop('success', 'Event Deleted !');
            
            modalInstance.result.then((result) => {
                if (result) {
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    promise = this.Calendar.removeEvent(this.event.id);
                    this.$state.go('^');
                    this.toaster.pop('success', 'Event Deleted !');
                } else {
                    this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
                }
            });
        }
        // promise.then(() => {
        //     this.$state.go('^');
        // }, (response) => {
        //     if (response.status === 403) {
        //         this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        //         this.toaster.pop('error', 'Permission Denied', "You don't have permission to delete this event.");
        //     } else if (response.status === 400) {
        //         this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        //         this.toaster.pop('warning', 'Validation Failed', response.data);
        //     } else {
        //         this.bsLoadingOverlayService.stop({referenceId: 'loader'});
        //         this.toaster.pop('error', 'Server Error', 'There was an error processing your request.');
        //     }
        // });
    }

    public setEventType(event: any): void {
        this.event.event_type = event;
    }

    public checkAllDayOption(): void {
        if (this.event.endTime !== null) {
            if (this.event.endTime.diff(this.event.startTime) >= 86340000) {
                this.event.allDay = true;
            } else {
                this.event.allDay = false;
            }
        }
    }
}

angular.module('beneple.calendar').controller('EditEventController', EditEventController);



// WEBPACK FOOTER //
// ./frontend/scripts/calendar/controllers/edit-event.controller.ts